import http from "../http-common";

const upload = (index, file, onUploadProgress) => {
  let formData = new FormData();

  //formData.append("file", file);
  
	// const index = 1;
  	const filename = 'photo_';
    const newfilename = filename.concat(index, '.jpg');
	console.log(newfilename);
	formData.append("file", file, newfilename);

	// formData.append("file", file);

  return http.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress,
  });
};

const getFiles = () => {
  return http.get("/files");
};

const FileUploadService = {
  upload,
  getFiles,
};

export default FileUploadService;
